import React, { FunctionComponent } from 'react';
import { CircularProgress, Grid } from '@material-ui/core';

const AppLoader: FunctionComponent = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
    style={{ minHeight: '100vh' }}
  >
    <Grid item xs={3}>
      <CircularProgress />
    </Grid>
  </Grid>
);

export default AppLoader;
